import { INameId } from '@modeso/types__aumico-lib-core-be';

export interface ILegalFormAndAccountBasisCombination {
    legalForm: INameId;
    accountBasis: INameId;
}
